import { useCallback, useState } from 'react'

const useForm = (initialValues = {}, initialErrors = {}) => {
  const [formDetails, setFormDetails] = useState(initialValues)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [showFormErrors, setShowFormErrors] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const sanitizeEmail = (value) =>
    value
      .replace(/\u00A0/g, ' ') // non-breaking space
      .replace(/[\u200B-\u200D\uFEFF]/g, '') // zero-width chars
      .trim()

  const onTextInputChange = useCallback((id, value, isValid) => {
    setFormDetails((state) => {
      return { ...state, [id]: ['userEmail', 'parentEmail', 'parent2Email'].includes(id) ? sanitizeEmail(value) : value }
    })

    setFormErrors((state) => {
      return { ...state, [id]: !isValid }
    })
  }, [])

  const onSelectInputChange = useCallback((id, value, isValid) => {
    console.log('id', id)
    console.log('id', value)
    setFormDetails((state) => {
      return { ...state, [id]: value }
    })

    console.log('Validation result', isValid)
    setFormErrors((state) => {
      return { ...state, [id]: !isValid }
    })
  }, [])

  const onMultiSelectInputChange = useCallback((id, value, isValid) => {
    setFormDetails((state) => {
      return { ...state, [id]: value }
    })

    console.log('Getting array of values', value)

    setFormErrors((state) => {
      return { ...state, [id]: !isValid }
    })
  }, [])

  const onRadioInputChange = useCallback((id, value, isValid) => {
    setFormDetails((state) => {
      return { ...state, [id]: value }
    })

    setFormErrors((state) => {
      return { ...state, [id]: !isValid }
    })
  }, [])

  const onDateInputChange = useCallback((id, value, isValid) => {
    setFormDetails((state) => {
      return { ...state, [id]: value }
    })

    setFormErrors((state) => {
      return { ...state, [id]: !isValid }
    })
  }, [])

  return {
    values: formDetails,
    errors: formErrors,
    showFormErrors,
    isLoading,
    setFormDetails,
    setShowFormErrors,
    onTextInputChange,
    onSelectInputChange,
    onRadioInputChange,
    onMultiSelectInputChange,
    onDateInputChange,
    setIsLoading,
  }
}

export default useForm
